import { render } from "./dealer.vue?vue&type=template&id=27cb5d08&scoped=true"
import script from "./dealer.vue?vue&type=script&lang=js"
export * from "./dealer.vue?vue&type=script&lang=js"

import "./dealer.vue?vue&type=style&index=0&id=27cb5d08&lang=scss&scoped=true"

import exportComponent from "/Users/jinjing/Desktop/jj/code1/HM0518/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27cb5d08"]])

export default __exports__